// Description: Page to update the template
// Updated: 06/08/2025
// Author: Simon Franklin


// React
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

// Material UI Components
import { Box, Grid, TextField, FormControl, useMediaQuery, Button, Typography, Tooltip } from '@mui/material';

// Components and Functions for the project
import use123zapStore from '../../context/123zapStore';
import HeaderPage from '../../components/HeaderPage/HeaderPage';
import { isAuthenticated } from '../../authMiddleware';
import { notify } from '../../utils/utils';
import Footer from '../../components/Footer/Footer';
import Loading from '../../components/Loading/Loading';
import themeColors from '../../components/ThemeColors/ThemeColors';
import { GetVariables } from '../../api/aws/Listagens/GetVariables';
import TemplateInput from '../../components/Input/TemplateInput';
import DynamicButton from '../../components/DynamicButton/DynamicButton';
import ThemeColors from '../../components/ThemeColors/ThemeColors';
import { GetAllTemplates } from '../../api/aws/Templates/GetAllTemplates';
import { TemplateUpdate } from '../../api/aws/Templates/UpdateTemplate';
import ModalR from '../../components/Modals/ModalR';
import EmailFormShowCase from '../../components/EmailFormShowCase/EmailFormShowCase';
import { TestMessage } from '../../api/aws/Templates/TestMessage';
import TestTemplateModal from '../../components/Modals/TestTemplateModal';

// Render The Component
const EditEmailTemplate = () => {

    const userAuthenticated = use123zapStore((state) => state.userAuthenticated);
    const planoAtual = use123zapStore((state) => state.planoAtual);
    const userInfo = use123zapStore((state) => state.userInfo);
    const setUserInfo = use123zapStore((state) => state.setUserInfo);
    const setAlreadyFetchTemplates = use123zapStore((state) => state.setAlreadyFetchTemplates);
    const templateId = localStorage.getItem("templateId") || null;

    const Navigate = useNavigate();
    const [title, setTitle] = useState('');
    const isSmallScreen = useMediaQuery('(max-width:1200px)');
    const [showPreview, setShowPreview] = useState(false);
    const [disabledTestModal, setDisabledTestModal] = useState(false);
    const [emailTitle, setEmailTitle] = useState('');
    const [variablesOfTemplate, setVariablesOfTemplate] = useState({});
    const [messageTemporary, setMessageTemporary] = useState('');
    const typeChannel = "e-mail";
    const [showLoading, setShowLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const buttons = ['Atrasos', 'Avisos', 'Faturas', 'Inadimplências', 'Marketing', 'Outros'];
    const [openTestModal, setOpenTestModal] = useState(false);
    const [wppNumber, setWppNumber] = useState("");

    const [viewWhatsAppScreenProps, setViewWhatsAppScreenProps] = useState({
        messages: {
            messages: []
        }
    });

    useEffect(() => {
        if (userAuthenticated && Object.keys(userInfo).length === 0) {
            const { decryptedData } = isAuthenticated();
            setUserInfo(decryptedData);
        }
    }, [userAuthenticated, userInfo]);

    // Function to get the template data
    const fetchTemplatesData = async () => {
        try {

            const templatesData = await GetAllTemplates();

            console.log(templatesData);

            const items = templatesData.data
                .map((template) => {
                    return {
                        id: template.id,
                        title: template.title,
                        status: template.status,
                        msg_type: template.msg_type,
                        channel_type: template.channel_type,
                        type: template.type,
                        background: template.background,
                        message_json: template.message_json,
                    };
                })
                .filter((item) => item !== null);

            const findTemplate = items.find((item) => item.id === templateId);
            setTitle(findTemplate.title);
            setEmailTitle(findTemplate.message_json.messages[0].message[0].title);
            setMessageTemporary(findTemplate.message_json.messages[0].message[0].content);

        } catch (error) {
            console.error("Erro ao obter modelos:", error);
        } finally {
            setShowLoading(false);
        }
    };

    // Effect to Fetch Data from API
    useEffect(() => {
        if (userInfo["UUID"]) {
            fetchData();

            if (templateId === null) {
                Navigate("/modelos");
                return;
            }

            fetchTemplatesData();
        }
    }, [userInfo]);

    useEffect(() => {
        if (planoAtual !== 'UltraZap' && planoAtual !== 'ProZap') {
            Navigate('/acesso-restrito');
        }
    }, [planoAtual]);

    useEffect(() => {
        setViewWhatsAppScreenProps((prevProps) => ({
            ...prevProps,
            type: 'e-mail',
            messages: {
                messages: [],
            },
        }));

        setMessageTemporary('');

    }, [typeChannel]);

    useEffect(() => {
        setViewWhatsAppScreenProps((prevProps) => ({
            ...prevProps,
            messages: {
                messages: [{ id: prevProps.messages.messages.length + 1, type: 'e-mail', message: messageTemporary, fromMe: true, disabledRemove: true }],
            },
        }));

    }, [messageTemporary]);

    const [selected, setSelected] = useState('Atrasos');

    const handleClick = (button) => {
        setSelected(button);
    }

    const fetchData = async () => {
        try {
            const translations = {
                "Personal_information": "Informações Pessoais",
                "Contact": "Contato",
                "Address": "Endereço",
                "Financial_References": "Referências Financeiras"
            };

            const resultJson = await GetVariables();

            console.log('resultJson', resultJson);

            const result = resultJson.data.reduce((acc, item) => {
                const category = translations[item.category] || item.category;
                if (!acc[category]) {
                    acc[category] = [];
                }

                acc[category].push(item.variableName);

                return acc;
            }, {});

            setVariablesOfTemplate(result);

        } catch (error) {
            console.error('Error fetching data from API:', error);
        }
    };

    const saveTemplate = async () => {

        const get_messages = viewWhatsAppScreenProps.messages.messages.map((message) => {
            return {
                type: 'html',
                title: emailTitle,
                content: message.message
            };
        });

        let info = {};

        info = {
            'title': title,
            'messages': get_messages,
            'msg_type': selected,
            'channel_type': 'E-mail',
            'id_template': templateId
        };

        const resultJson = await TemplateUpdate(info);

        if (resultJson['status'] === 'success') {
            notify("Success", "Modelo criado com sucesso!", true);
            setAlreadyFetchTemplates(false);
            Navigate("/modelos");
        }
    }

    const sendTestMessage = async () => {
        let info = {};

        const get_messages = viewWhatsAppScreenProps.messages.messages.map((message) => {
            return {
                type: 'html',
                content: message.message
            };
        });

        info = {
            title: title,
            messages: get_messages,
            msg_type: selected,
            channel_type: 'E-mail',
            number: wppNumber
        };


        await TestMessage(info).then((response) => {
            if (response.status === "success") {
                notify("Success", "Mensagem enviada com sucesso!", true);
            } else {
                notify("Error", "Ocorreu algum erro, tente novamente mais tarde.", true);
            }
            
            setOpenTestModal(false);
        })
    }

    const verifyFieldsBeforeSave = async () => {
        if (title === "") {
            notify("Error", "Preencha o título do modelo", true);
        } else if (emailTitle === "") {
            notify("Error", "Preencha o título do e-mail", true);
        } else if (messageTemporary === "") {
            notify("Error", "Escreva uma mensagem antes de salvar o modelo", true);
        } else {
            setOpenModal(true);
        }
    }

    if (showLoading) {
        return <Loading open={true} />;
    }

    return (
        <>
            <HeaderPage />
            <Box sx={{  background: "#F7F7FC" }}>
                <Grid container spacing={2} style={{ paddingTop: '20px' }}>
                    <Grid item xs={12} lg={6} xl={6} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Box sx={{ flexGrow: 1, justifyContent: 'center', backgroundColor: '#F7F7FC', width: { xs: 'calc(100% - 20px)', sm: "561.200px", lg: "90%" }, margin: { xs: '0 auto 20px', lg: '0 auto' }, padding: { xs: 0, lg: "20px 0px 20px 30px", xl: "20px" } }}>
                            <FormControl fullWidth>
                                <TextField
                                    id="outlined-basic"
                                    label="Nome do seu Modelo"
                                    variant="standard"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    InputLabelProps={{
                                        style: { fontSize: '20px' }
                                    }}

                                />
                            </FormControl>

                            <Box item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                {buttons.map((button, index) => (
                                    <Button
                                        key={button}
                                        onClick={() => handleClick(button)}
                                        sx={{
                                            flexGrow: 1,
                                            mx: index === 0 || index === buttons.length - 1 ? 0 : 0.5,
                                            bgcolor: selected === button ? '#8142FC' : ThemeColors.gray30,
                                            color: '#fff',
                                            borderRadius: '27px',
                                            '&:hover': { bgcolor: selected === button ? '#8142FC' : 'gray' },
                                            fontSize: { xs: '11px', xl: '12px' },
                                            padding: { xs: '3px 12px', xl: '4px 16px' }
                                        }}
                                    >
                                        {button}
                                    </Button>
                                ))}
                            </Box>

                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                gap={"5px"}
                                minWidth={"100%"}
                                sx={{ paddingTop: '20px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                            >
                                <Typography

                                    color={"#52525B"}
                                    sx={{
                                        fontSize: { xs: '18px', sm: '18px' },
                                        fontWeight: 500,
                                        fontFamily: 'Satoshi',
                                        marginBottom: '5px'
                                    }}

                                >Título do Email (assunto)
                                </Typography>

                                <TextField
                                    placeholder="Digite o título aqui :)"
                                    fullWidth
                                    rows={1}
                                    variant="outlined"
                                    value={emailTitle}
                                    onChange={(e) => setEmailTitle(e.target.value)}
                                    autoComplete="off"
                                    style={{
                                        background: "white",
                                        color: "black",
                                        borderRadius: "12px",
                                        margin: 0,
                                        border: `1px solid ${themeColors.gray20}`,
                                        color: themeColors.gray40,
                                    }}
                                    sx={{
                                        ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":
                                        {
                                            padding: "14px",
                                        },
                                        ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                            borderRadius: "6px",
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ paddingTop: { xs: '20px', sm: '0px' }, marginBottom: (isSmallScreen && showPreview) ? '20px' : 'none', position: 'relative' }}>
                                <Box sx={{
                                    color: 'rgb(129, 66, 252)',
                                    fontSize: '18px',
                                    position: 'absolute',
                                    top: { xs: (typeChannel === 'WhatsApp' || typeChannel === 'SMS') ? '16px' : (typeChannel === 'E-mail' && showPreview) ? '16px' : '0px', sm: (typeChannel === 'WhatsApp' || typeChannel === 'SMS') ? '16px' : (typeChannel === 'E-mail' && showPreview) ? '16px' : '0px' },
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    display: isSmallScreen ? 'block' : 'none',
                                    fontFamily: 'Satoshi',
                                    cursor: 'pointer',
                                    zIndex: '10'
                                }} onClick={() => setShowPreview(prev => !prev)}>
                                    {
                                        !showPreview ? "Exibir Prévia" : "Esconder Prévia"
                                    }
                                </Box>

                                <Box sx={{
                                    display: (isSmallScreen && showPreview) ? 'none' : 'block'
                                }}>
                                    <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                        <TemplateInput type={'email'} value={messageTemporary} handleChange={setMessageTemporary} variablesOfTemplate={variablesOfTemplate} />

                                        <Grid item xs={6}>
                                            <FormControl fullWidth sx={{ justifyContent: 'flex-end' }}>
                                                {disabledTestModal ? (
                                                    <Tooltip arrow title="Após a edição do modelo, é necessário salvá-lo e aguardar a análise antes de enviá-lo ou testá-lo.">
                                                        <span>
                                                            <Button
                                                                disabled
                                                                onClick={() => setOpenTestModal(true)}
                                                                sx={{
                                                                    width: '100%',
                                                                    padding: '13px',
                                                                    background: themeColors.purple300,
                                                                    '&:hover': { background: themeColors.purple400 },
                                                                    color: themeColors.purple700,
                                                                }}
                                                                variant="contained"
                                                            >
                                                                Testar Envio
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <Button
                                                        onClick={() => setOpenTestModal(true)}
                                                        sx={{
                                                            width: '100%',
                                                            padding: '13px',
                                                            background: themeColors.purple300,
                                                            '&:hover': { background: themeColors.purple400 },
                                                            color: themeColors.purple700,
                                                        }}
                                                        variant="contained"
                                                    >
                                                        Testar Envio
                                                    </Button>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth sx={{ justifyContent: 'flex-end' }}>
                                                <DynamicButton handleFunction={verifyFieldsBeforeSave} style={{ width: '100%', padding: '13px' }} variant={"contained"} text={"Editar Modelo"} />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>

                            <Box sx={{ display: { xs: 'none', lg: 'flex' }, justifyContent: 'start', alignItems: 'end', minHeight: '80px' }}>
                                <Footer />
                            </Box>
                        </Box>
                    </Grid>
                    {
                        (isSmallScreen && showPreview === true) ? (
                            <Grid item xs={12} lg={6} xl={6} padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}>
                                <EmailFormShowCase title={emailTitle} titleModel={title} message={messageTemporary} />
                            </Grid>
                        ) : (!isSmallScreen) ? (
                            <Grid item xs={12} lg={6} xl={6} padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}>
                                <EmailFormShowCase title={emailTitle} titleModel={title} message={messageTemporary} />
                            </Grid>
                        ) : null
                    }
                    <Box sx={{ padding: { xs: "20px 0 0 25px", sm: "20px 0 0 0" }, display: { xs: "block", lg: "none" }, width: { xs: "100%", sm: "561.200px", lg: "100%", xl: "100%" }, margin: { sm: "0 auto", lg: "0", xl: "0" } }}>
                        <Footer />
                    </Box>
                </Grid>
            </Box>
            <TestTemplateModal channelType={"E-mail"} isOpen={openTestModal} onClose={() => setOpenTestModal(false)} onConfirm={sendTestMessage} wppNumber={wppNumber} setWppNumber={setWppNumber} />
            <ModalR
                cancelText={"Mudei de ideia"}
                color={themeColors.purple500}
                confirmText={"Salvar alterações"}
                subTitle={"Deseja salvar as alterações feitas no modelo?"}
                isOpen={openModal}
                onClose={() => setOpenModal(false)}
                onConfirm={async () => await saveTemplate()}
                title={"Editar Modelo"}
                emoji={"emoji01"}
                iconColor={themeColors.purple400}
            />
        </>
    )
}

export default EditEmailTemplate